import React, { Component } from "react";

const user_name = localStorage.getItem("user_name");

function Notification() {}

export default Notification;
